// LQC-2941 (spec F3) - DV01 and size, linked both ways for Bond and Future:
//   DV01 = Risk x Nominal / 10,000   and   Nominal = DV01 / Risk x 10,000
// Risk is the security's latest dbo.KeyRatio "Risk", served on GET /Securities/{bonds,futures}.
// Checked 9 Oct against the backend's stored dV01 on fresh blocks: within 0.01-0.07%.

export const DV01_RISK_SCALE = 10000;

function isUsableRisk(risk: number | null | undefined): risk is number {
  return typeof risk === "number" && isFinite(risk) && risk !== 0;
}

export function returnDV01ForSize(
  risk: number | null | undefined,
  size: number | null | undefined,
): number | null {
  if (!isUsableRisk(risk) || typeof size !== "number" || !isFinite(size)) return null;
  return (risk * size) / DV01_RISK_SCALE;
}

export function returnSizeForDV01(
  risk: number | null | undefined,
  dv01: number | null | undefined,
): number | null {
  if (!isUsableRisk(risk) || typeof dv01 !== "number" || !isFinite(dv01)) return null;
  return Math.abs((dv01 / risk) * DV01_RISK_SCALE);
}

export function hasRisk(risk: number | null | undefined): boolean {
  return isUsableRisk(risk);
}

// What a user types: "5000", "5,000", "5k" or "5 k" (the grid shows thousands as "k").
export function parseDV01Input(text: string): number | null {
  const match = /^\s*(\d[\d,]*\.?\d*)\s*(k?)\s*$/i.exec(text);
  if (!match) return null;
  const value = Number(match[1].replace(/,/g, ""));
  if (!isFinite(value)) return null;
  return match[2] ? value * 1000 : value;
}
